// src/components/admin/SessionExpiredModal.tsx
// Modal Bootstrap para mostrar cuando la sesión expira
import React from 'react';
import './SessionExpiredModal.css';

interface SessionExpiredModalProps {
  show: boolean;
  onConfirm: () => void;
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ show, onConfirm }) => {
  if (!show) return null;

  return (
    <div className="session-expired-overlay">
      <div className="session-expired-modal">
        <div className="modal-icon">
          <i className="fas fa-clock"></i>
        </div>
        
        <h3>Sesión Expirada</h3>
        
        <p>
          Tu sesión ha expirado por inactividad.
          <br />
          Por favor inicia sesión nuevamente.
        </p>
        
        <button className="btn-confirm" onClick={onConfirm}>
          <i className="fas fa-sign-in-alt"></i>
          Ir a Inicio de Sesión
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
